import { render } from "./StudyShareDialog.vue?vue&type=template&id=1ae79cdb&scoped=true"
import script from "./StudyShareDialog.vue?vue&type=script&lang=js"
export * from "./StudyShareDialog.vue?vue&type=script&lang=js"

import "./StudyShareDialog.vue?vue&type=style&index=0&id=1ae79cdb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae79cdb"]])

export default __exports__